import { useSearchParams } from 'react-router';

import type { RoutePath } from '#/routing/classes/RoutePath';

/**
 * Prefer getting the search params in the loader, but in some cases
 * we use `defaultShouldRevalidate: false` so we need to get the
 * search param client-side.
 */
export function useRouteSearchParams<
  T extends RoutePath<string, string, string, string>,
>(routePath: T) {
  const [searchParams] = useSearchParams();

  const values = routePath.searchParams.reduce(
    (acc, name) => Object.assign(acc, { [name]: searchParams.get(name) }),
    {},
  );

  const arrayValues = routePath.arraySearchParams.reduce(
    (acc, arrayName) =>
      Object.assign(acc, { [arrayName]: searchParams.getAll(arrayName) }),
    {},
  );

  return { ...values, ...arrayValues } as Partial<
    Record<T['searchParams'][number], string>
  > &
    Record<T['arraySearchParams'][number], string[]>;
}
